export default "__VITE_ASSET__C5rpQOGg__"